import { ReactNode } from 'react';
import { FeatureConfigContext, useFeatureVisibility, useExplicitFeatureFlag } from './context';
import { featureConfig } from '@internal-config/features';
import { FeatureFlagPath } from '@/constants/features';
import type { FeatureConfig } from './types';

interface FeatureConfigProviderProps {
    children: ReactNode;
}

export const FeatureConfigProvider = ({ children }: FeatureConfigProviderProps) => {
    return (
        <FeatureConfigContext.Provider value={featureConfig as FeatureConfig}>
            {children}
        </FeatureConfigContext.Provider>
    );
};

interface WithFeatureVisibilityProps {
    children: ReactNode;
    name: FeatureFlagPath | string;
}

export const WithFeatureVisibility = ({ children, name }: WithFeatureVisibilityProps) => {
    const isVisible = useFeatureVisibility(name);
    return isVisible ? children : null;
};

interface WithExplicitFeatureFlagProps {
    children: ReactNode;
    name: FeatureFlagPath | string;
}

export const WithExplicitFeatureFlag = ({ children, name }: WithExplicitFeatureFlagProps) => {
    const isEnabled = useExplicitFeatureFlag(name);
    return isEnabled ? children : null;
};
